<script setup lang="ts">
const props = defineProps<{
  slide: any;
}>();

const { slide } = props;
</script>
<template>
  <div class="flex flex-col-reverse md:grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="left">
      <div v-html="slide.sliderText" class="wrap-details bg-light-grey p-4 md:p-6 lg:p-10 rounded-lg h-full">
      </div>
    </div>

    <div class="right">
      <div class="wrap-img">
        <figure>
          <NuxtImg
            format="webp"
            v-if="slide.sliderImage.media"
            :src="slide.sliderImage.media.url"
            class="w-full h-auto object-cover rounded-lg aspect-[6/4]"
            :alt="slide.sliderImage.media.alt"
            loading="eager"
            :width="slide.sliderImage.media.metaData.width"
            :height="slide.sliderImage.media.metaData.height"
          />
        </figure>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
